import type { FC, ReactNode } from 'react'
import type { LucideProps } from 'lucide-react'

import {
    Apple,
    Banana,
    Bean,
    Carrot,
    Cookie,
    Flame,
    Gift,
    Nut,
    Popcorn,
    Sparkles,
    Sprout
} from 'lucide-react'

const ICONS: Record<string, FC<LucideProps>> = {
    'keripik-pisang': Banana,
    'keripik-singkong': Sprout,
    'keripik-tempe': Bean,
    'keripik-buah': Apple,
    'keripik-sayuran': Carrot,
    'aneka-camilan': Popcorn,
    'produk-terbaru': Sparkles,
    'produk-terlaris': Flame,
    'paket-hemat': Gift,
    kacang: Nut
}

export const CategoryIcon: FC<LucideProps & { slug: string }> = ({ slug, ...props }): ReactNode => {
    const Icon = ICONS[slug] ?? Cookie

    return <Icon aria-hidden='true' {...props} />
}
